import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { InputTextComponent } from '../../../../../components/prime-formik';

const SuperProfilePublicTitleInput = () => {
  return (
    <div className="p-col-12">
      <FormattedMessage id="account.super-profiles.new.public-title.label" defaultMessage="Public job title">
        {(text) => (
          <label className="field-label" htmlFor="publicTitle">
            <strong>{text}</strong>
          </label>
        )}
      </FormattedMessage>
      <FormattedMessage
        id="account.super-profiles.new.public-title.placeholder"
        defaultMessage="Enter the job title to be published in GROW"
      >
        {(text) => (
          <Field
            id="publicTitle"
            name="publicTitle"
            component={InputTextComponent}
            className="width-full"
            placeholder={text}
          />
        )}
      </FormattedMessage>
    </div>
  );
};

export default SuperProfilePublicTitleInput;
